export default "__VITE_ASSET__Dzx5IBZH__"